<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import CardTag, { type Variant } from "./CardTag.svelte";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  /** multiple text tags */
  export let tags: string[] = [];

  /** variant */
  export let variant: Variant = "dark";
</script>

<!-- Template ----------------------------------------------------------------->

<div class="flex flex-row flex-wrap items-center justify-end gap-1">
  {#each tags as tagText}
    <CardTag text={tagText} {variant} size="small" />
  {/each}
</div>
